'use strict'

// Do not remove/change exsiting values
module.exports = {
  ERROR: 1,
  UNHANDLED_REJECTION: 2, // unused

  //DBSM Load Failures
  DATASET_FAILED_TO_LOAD: 3,
  CONNECTION_CONFIG_FAILED_TO_LOAD: 4,
  FILTER_PANEL_FAILED_TO_LOAD: 5,
  SORT_PANEL_FAILED_TO_LOAD: 6,
  ADD_COLUMN_PANEL_FAILED_TO_LOAD: 7,
  CHANGE_COLLECTION_PANEL_FAILED_TO_LOAD: 8,
  CREATE_DATASET_PANEL_FAILED_TO_LOAD: 9,
  NEW_DYNAMIC_PAGE_PANEL_FAILED_TO_LOAD: 10,
  DELETE_DYNAMIC_PAGE_PANEL_FAILED_TO_LOAD: 11,
  DYNAMIC_PAGE_INFO_PANEL_FAILED_TO_LOAD: 12,
  DYNAMIC_PAGE_SEO_PANEL_FAILED_TO_LOAD: 13,
  DYNAMIC_PAGES_HOOKS_PANEL_FAILED_TO_LOAD: 14,
  ERROR_PANEL_FAILED_TO_LOAD: 15,
  ADD_FIELD_PANEL_FAILED_TO_LOAD: 16,

  //Custom Router Load Failures
  CONNECT_PAGE_FAILED_TO_LOAD: 21,
  DELETE_PAGE_FAILED_TO_LOAD: 22,
  NEW_PAGE_FAILED_TO_LOAD: 23,
  PAGE_INFO_FAILED_TO_LOAD: 24,
  PAGE_SEO_FAILED_TO_LOAD: 25,
  UPDATE_PREFIX_FAILED_TO_LOAD: 26,
  WEB_MODULES_PERMISSONS_FAILED_TO_LOAD: 27,

  // NPM modules
  NPM_MODULES_MANAGEMENT_PANEL_FAILED_TO_LOAD: 79,
  REMOVE_NPM_PACKAGE_PANEL_FAILED_TO_LOAD: 79
}
